import { cn } from '@/utils/tailwind-util';
import { Tooltip } from '@mui/material';
import { observer } from 'mobx-react';

import useToast from '@/hooks/useToast';
import { useFetchVenueService, useUpdateService } from '@/services';

import { VenueServiceStoreProvider, useVenueServiceStore } from '../store';

const getVenueId = () => {
  const pathArr = location.pathname.split('/');
  return Number(pathArr[pathArr.length - 1]);
};

export default observer(function VenueService() {
  const store = useVenueServiceStore();
  const toast = useToast();

  useFetchVenueService({ vid: getVenueId() });

  const { mutate, isLoading } = useUpdateService({
    vid: getVenueId(),
    onSuccess: function () {
      // 처리할 게 있나
    },
    onError: function ({ errorCode }) {
      toast.error(errorCode);
    },
  });

  const handleClick = (service) => () => {
    mutate({
      serviceId: service.pk,
      used: !service.used,
    });
  };
  return (
    <VenueServiceStoreProvider>
      <p className="text-lg font-semibold">제공중인 서비스</p>
      <p className="mt-2 font-medium text-[#8b8b8b]">
        클릭하여 on/off할 수 있습니다
      </p>
      <div className="mt-6 grid grid-cols-5 place-items-center justify-center gap-5">
        {store.services.map((service) => (
          <Tooltip
            placement="bottom-start"
            title={
              <div className="min-w-56 flex h-auto w-auto flex-col gap-2">
                <div className="flex flex-1 justify-between">
                  <p className="font-semibold text-base text-[#fff]">
                    {service.title}
                  </p>
                  <p
                    className={cn(
                      'flex h-6 w-12 items-center justify-center rounded-[4px] font-medium',
                      service.used
                        ? 'bg-[#e6f8f6] text-[#4f64d7]'
                        : 'bg-[#f5f5f5] text-[#8b8b8b]'
                    )}
                  >
                    {service.used ? '이용중' : '이용전'}
                  </p>
                </div>
                <p className="text-sm text-[#fff]">{service.description}</p>
              </div>
            }
            key={service.title}
          >
            <button
              className={cn(
                'flex h-[61px] w-[61px] items-center justify-center rounded bg-[#fbfbfb] hover:border-[1px] hover:border-solid hover:border-[#4f64d7] hover:bg-[#c3cfff]',
                service.used
                  ? 'border-[1px] border-solid border-[#4f64d7]'
                  : 'opacity-40'
              )}
              disabled={isLoading}
              onClick={handleClick(service)}
              // @ts-ignore
              used={service.used}
            >
              <img
                width={32}
                height={32}
                src={service.image.thumbnailPath}
                alt="서비스 아이콘"
              />
            </button>
          </Tooltip>
        ))}
      </div>
    </VenueServiceStoreProvider>
  );
});
